/* eslint-disable no-restricted-globals */

export const initializeAppKey = () => {
    // ブラウザのリターンボタンの無効化
    history.pushState(null, "", null)

    window.addEventListener("popstate", () => {
        history.pushState(null, "", null)
    })

    // ブラウザのF5キーを無効化
    window.addEventListener("keydown", (event: KeyboardEvent) => {
        if (event.code === "F5") {
            event.preventDefault()
        }
    })
}
